import request from '@/utils/request'

export function selectSpecialProcess(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/specialProcess/selectSpecialProcess?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function addSpecialProcess(data) {
    return request({
        url: `api/serviceCenter/specialProcess/addSpecialProcess`,
        method: 'post',
        data,
    })
}

export function upSpecialProcess(data) {
    return request({
        url: `api/serviceCenter/specialProcess/upSpecialProcess`,
        method: 'post',
        data,
    })
}

export function bathDeletePieceworkSet(data) {
    return request({
        url: `api/serviceCenter/specialProcess/bathDeletePieceworkSet`,
        method: 'post',
        data,
    })
}







